import { Dialog, Transition } from "@headlessui/react";
import React, { useState, Fragment, useRef } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner";

// import { Container } from './styles';

function LoadingModal({ cancelar, back }) {
  const cancelButtonRef = useRef(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  return (
    <Transition.Root show as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={() => ""}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative justify-center transform overflow-hidden rounded-[8px] transition-all sm:my-8 sm:w-full sm:max-w-lg">
                
                {loading && <Spinner />}
              </Dialog.Panel>
              
            </Transition.Child>
          </div>
        </div>
        
      </Dialog>
    </Transition.Root>
  );
}

export default LoadingModal;
